import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-[#F7F5F0]" data-id="element-245">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-24" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-247">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-8 text-center" data-id="element-248">
            El Miedo Más Grande No Es Fallar la Prueba de Historia
          </h2>

          <div className="space-y-6" data-id="element-249">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-250">
              Es quedarse en blanco cuando el oficial te hace una pregunta en
              inglés y tu mente se congela.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-251">
              Es saber la respuesta en español pero no poder decirla en inglés
              en ese momento.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-252">
              Es llegar al día de la entrevista sin haber practicado con alguien
              que te haga las preguntas como las va a hacer el oficial de
              verdad.
            </p>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.2
          }} className="bg-white border-l-4 border-[#C9A84C] p-6 rounded-r-lg shadow-sm mt-8" data-id="element-253">
              <div className="flex items-start gap-3" data-id="element-254">
                <AlertTriangleIcon className="w-6 h-6 text-[#C9A84C] flex-shrink-0 mt-1" data-id="element-255" />
                <p className="text-[#1B2A4A] font-semibold text-lg" data-id="element-256">
                  Eso es lo que separa a los que pasan de los que tienen que
                  regresar a intentarlo otra vez.
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}